import React from "react";
import Directory from "../../components/directory/directory.components";
import "./homepage.styles.scss";

const HomePage = () => (
  <>
    <div className="homepage">
      <Directory></Directory>
    </div>
  </>
);

export default HomePage;
